import React, { Component } from 'react';

class QuizOptions extends Component {
  render() {
    return (
      <div>
        <div className="cards">
          <div className={"card "}>
            <h3 className="font-large">Gender Quiz</h3>
            <p>
              Nouns in Spanish have <b>gender</b>, even inanimate ones!
              This can be one of the hardest concepts to grasp from the perspective
              of a native English speaker. Brush up on these concepts here!
              <a href="/practice" className="button">Quiz Me!</a>
            </p>
          </div>
          <div className={"card "}>
            <h3 className="font-large">Common Phrases</h3>
            <p>
              <i>"Where's the bathroom?"</i>, <i>"What's your name?"</i>,
              <i>"Do you speak English?"</i> <br />
              Learn the most common phrases in Spanish with these Flash Cards!
              <a href="/practice" className="button male">Start Learning</a>
            </p>
          </div>
        </div>
        <div className="backbutton-holder">
          <a className="button gray" href="/">
            &larr; Back to Languages
          </a>

        </div>
      </div>
    );
  }
}

export default QuizOptions;
